<!-- eslint-disable vue/no-v-html -->
<template>
  <component :is="type">
    <p
      v-if="!url"
      ref="citation"
      class="a-bibliography__citation"
      data-testid="citation"
      v-html="content"
    />
    <p
      v-else
      ref="citation"
      class="a-bibliography__citation"
      data-testid="citation"
    >
      <GuiLink
        ref="citationLink"
        :href="url"
        target="_blank"
        class="a-bibliography__citation--link"
      >
        <span v-html="content" />
      </GuiLink>
    </p>
  </component>
</template>
<script>
import { GuiLink, useEventBus } from "@thegetty-private/getty-ui";
export default {
  name: "BibliographyItem",
  components: { GuiLink },
  provide() {
    return {
      analyticsListener: (_event, url, _to) => {
        this.logEvent(url);
      }
    };
  },
  props: {
    url: {
      type: String,
      required: false,
      default: null
    },
    content: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: "div"
    }
  },
  data() {
    return {
      /**
       * Event bus composable instance
       */
      eventBus: useEventBus()
    };
  },
  methods: {
    /**
     * Log the click event
     *
     * @param {string} url the url
     */
    logEvent(url) {
      this.eventBus.emit("AnalyticsEvent", {
        action: "bibliography resource",
        category: "Bibliography Click",
        label: url,
        noninteraction: true
      });
    }
  }
};
</script>
<style lang="scss">
@import "./index.scss";
</style>
